export const MENU_ITEM_NAME = 'Menu Item Name';
export const RESTAURANT_ID  ='sglPPggI9WufHEOJwsXg';
export const RESTAURANT_NAME = 'Curry King Test';